<fa-duotone-icon
  [icon]="['fad', 'plus-circle']"
  [ngClass]="{ disabled: isDisabled }"
  [matTooltip]="textTooltip"
  [matTooltipPosition]="tooltipPosition"
  [matTooltipClass]="'dark-theme-tooltip simple ' + tooltipPosition"
></fa-duotone-icon>
